import { createActions } from 'redux-actions';

const feedbackActions = createActions(
  'FEEDBACK_REQUEST',
  'FEEDBACK_REQUEST_SUCCEEDED',
  'FEEDBACK_REQUEST_FAILED',
);

export { feedbackActions };
